import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['Llegás al entrenamiento sin saber exactamente qué ejercicio vas a trabajar hoy', 'Tus jugadores no progresan porque no tenés una secuencia clara de sesión a sesión', 'El 40% de los pibes abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos 10 o 15 ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de cuota porque no tenés un sistema profesional visible', 'Las correcciones son improvisadas, sin un método claro que te respalde', 'Tenés jugadores de distintos niveles juntos y el entrenamiento se convierte en un caos', 'Fin de mes y los chicos se van sin avisar porque no hay progresión ni sistema de comunicación'];
  return <Section dark className="bg-dark" data-id="element-274">
      <div className="max-w-4xl mx-auto" data-id="element-275">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-6 md:mb-12 leading-tight" data-id="element-276">
          Si sos instructor de fútbol en Argentina,{' '}
          <span className="text-red-500" data-id="element-277">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-2 md:space-y-4 mb-6 md:mb-16" data-id="element-278">
          {pains.map((pain, i) => <div key={i} className="flex items-start bg-white/5 p-3 md:p-6 rounded-xl border border-white/10" data-id="element-279">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 mr-3 md:mr-4 flex-shrink-0 mt-0.5" data-id="element-280" />
              <p className="text-sm md:text-xl text-gray-200 font-medium" data-id="element-281">
                {pain}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-282">
          <h3 className="text-2xl md:text-4xl font-black text-gold" data-id="element-283">
            ¿Cuántos entrenamientos más vas a improvisar?
          </h3>
        </div>
      </div>
    </Section>;
}